import { render } from "./Recovery.vue?vue&type=template&id=ccdfe4d6"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__